<app-header #header [headerMenu]="headerMenu"> </app-header>

<router-outlet></router-outlet>

<button (click)="scrollToTop()" class="to-top" [ngClass]="{ shown: toTopShown }" [attr.aria-label]="'label.to-top' | translate"></button>

<app-sz-2020-logo></app-sz-2020-logo>

<app-emese-chatbot *ngIf="isChatbotVisible"></app-emese-chatbot>

<app-footer [footerMenu]="footerMenu" (openHeaderNav)="navContentChange($event)"></app-footer>
